import React from "react";

import {

    createLeaseAssets,

    createLeaseContract,

    removeLeaseAssets,

    removeLeaseContract,

    removeLeases,

    updateLease

} from "../../../../../api/asset/AssetLeaseService";

import Th_title from "../../../../../components/Th_title";

import {commonResponseMessage} from "../../../../../components/commonmethod/CommonMethod";

import {
    ContentDetailTwoColLayout,
    DetailEntityShell,
    DetailFilePanel,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
    DetailRollupActions,
    useDetailEditing,
} from "../../../../../components/detailLayout";
import {useNavigate} from "react-router-dom";

import {inputOnChange, inputOnKeyDown} from "../../../../../components/commonmethod/simmsInputMethod";

import SimmsInput from "../../../../../components/input/SimmsInput";

import {onUpdateClickListener} from "../../../../../components/commonmethod/simmsDrawerMethod";

import Selector from "../../../../../components/selector/Selector";

import SimmsDatePicker from "../../../../../components/datepicker/SimmsDatePicker";

import {dateOnChange, dateOnSelected} from "../../../../../components/commonmethod/simmsDateMethod";

import dayjs from "dayjs";

import {cn} from "../../../../../shadCn/lib/utils";

import SimmsTextArea from "../../../../../components/input/SimmsTextArea";

import SearchSelector from "../../../../../components/searchSelector/SearchSelector";

import UserSelectionField from "../../../../../components/selection/UserSelectionField";


import {AssetSearchFilters} from "../../../mng/info/shared/AssetSearchFilters";

import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";

import {handleActiveError} from "../../../../../components/sonner/ToastBasic";

import {useSelector} from "react-redux";



function buildLeaseMeta(lease) {

    return [

        lease.number && `계약번호 ${lease.number}`,

        lease.company?.name && `업체 ${lease.company.name}`,

    ]

        .filter(Boolean)

        .join(" · ");

}



function AssetLeaseInfo(props) {

    const navigate = useNavigate();

    if (!props.lease) return null;

    const remove = async () => {
        const response = await removeLeases({ids: [props.lease.id]});
        if (response?.status === 200) {
            alert("리스가 정상적으로 삭제되었습니다.");
            navigate("/asset/lease");
        }
    };

    return (

        <DetailEntityShell

            title={props.lease.name || "리스상세"}

            meta={buildLeaseMeta(props.lease)}

            canUpdate={props.lease.auth?.update}

            listUrl="/asset/lease"

            scrollMode="columns"

            rollupActions={props.lease.auth?.delete ? <DetailRollupActions remove={remove} /> : null}

        >

            <AssetLeaseInfoBody {...props} />

        </DetailEntityShell>

    );

}



function AssetLeaseInfoBody({lease, setLease, assets, setAssets, contracts, setContracts}) {

    const platFrom = useSelector((state) => state.auth.platFrom);

    const isEditing = useDetailEditing();

    const fieldAuth = isEditing && lease.auth?.update;



    const AssetsDeleteHandler = async (id, data) => {

        await removeLeaseAssets(id, data).then((response) => {

            if (response.status === 200) {

                setAssets((prevState) => prevState.filter((asset) => asset.id !== data.id));

                return commonResponseMessage(response, false, "자산");

            } else if (response.status === 201 || response.status === 202) {

                handleActiveError({message: response.data.title, description: response.data.reason});

            }

        });

    };



    const handleAssetsMultiFlat = async (list) => {

        const next = Array.isArray(list) ? list.filter(Boolean) : [];

        const prevIds = new Set((assets ?? []).map((a) => a.id));

        const nextIds = new Set(next.map((a) => a.id));



        for (const item of next) {

            if (!prevIds.has(item.id)) {

                const response = await createLeaseAssets(lease.id, item);

                if (response.status === 200) {

                    setAssets((prev) => [...prev, item]);

                    commonResponseMessage(response, true, "자산");

                } else if (response.status === 201 || response.status === 202) {

                    handleActiveError({

                        message: response.data.title,

                        description: response.data.reason,

                    });

                }

            }

        }



        for (const item of assets ?? []) {

            if (!nextIds.has(item.id)) {

                await AssetsDeleteHandler(lease.id, item);

            }

        }

    };



    const ContractDeleteHandler = async (id, data) => {

        await removeLeaseContract(id, data).then((response) => {

            if (response.status === 200) {

                setContracts((prevState) => prevState.filter((contract) => contract.id !== data.id));

                return commonResponseMessage(response, false, "계약");

            } else if (response.status === 201 || response.status === 202) {

                handleActiveError({message: response.data.title, description: response.data.reason});

            }

        });

    };



    const handleContractsMultiFlat = async (list) => {

        const next = Array.isArray(list) ? list.filter(Boolean) : [];

        const prevIds = new Set((contracts ?? []).map((c) => c.id));

        const nextIds = new Set(next.map((c) => c.id));



        for (const item of next) {

            if (!prevIds.has(item.id)) {

                const response = await createLeaseContract(lease.id, item);

                if (response.status === 200) {

                    setContracts((prev) => [...prev, item]);

                    commonResponseMessage(response, true, "계약");

                } else if (response.status === 201 || response.status === 202) {

                    handleActiveError({

                        message: response.data.title,

                        description: response.data.reason,

                    });

                }

            }

        }



        for (const item of contracts ?? []) {

            if (!nextIds.has(item.id)) {

                await ContractDeleteHandler(lease.id, item);

            }

        }

    };



    const renderSelectionList = ({

        data,

        countUnit,

        entity,

        uniqueKey,

        placeHolder,

        onRemove,

        onMultiFlat,

        filters,
        listModalTitle,

    }) =>

        isEditing ? (

            <UserSelectionField
                layout="inline"
                data={data}
                countUnit={countUnit}
                chipEntity={entity}
                listModalTitle={listModalTitle}
                onRemove={onRemove}
            >

                <SearchSelector

                    auth={fieldAuth}

                    multiSelect

                    variant="compact"

                    entity={entity}

                    uniqueKey={uniqueKey}

                    data={data}

                    placeHolder={placeHolder}

                    onChange={(v) => {

                        if (v?.__multiFlat) {

                            onMultiFlat(v.__multiFlat);

                        }

                    }}

                >

                    {filters}

                </SearchSelector>

            </UserSelectionField>

        ) : (

            <DetailKvListValue
                items={data}
                listType={entity === "asset" ? KV_LIST_TYPES.asset : KV_LIST_TYPES.contract}
            />

        );



    return (

        <ContentDetailTwoColLayout

            main={

            <DetailPanel title="기본정보">

                <DetailKvTable>

                    <tbody>

                    <tr>

                        <DetailKvReadOnly label="등록일시" value={lease.createdAt} type="date" />

                        <DetailKvReadOnly label="수정일시" value={lease.updatedAt} type="date" />

                    </tr>

                    <tr>

                        <DetailKvReadOnly label="등록자" value={lease.createdBy} />

                        <DetailKvReadOnly label="수정자" value={lease.updatedBy} />

                    </tr>

                    <tr>

                        <Th_title title={"리스명"} colspan={3} className="fieldset-td" required auth={fieldAuth}>

                            <SimmsInput

                                onChange={(v) => inputOnChange(setLease, "name", v, true)}

                                update

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(setLease, updateLease, lease.id, "name", v, e, true)

                                }

                                data={lease.name}

                            />

                        </Th_title>

                    </tr>

                    <tr>

                        <Th_title title={"리스 계약차수"} colspan={1} className="fieldset-td" auth={fieldAuth}>

                            <SimmsInput

                                onChange={(v) => inputOnChange(setLease, "contractCount", v, false)}

                                update

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(

                                        setLease,

                                        updateLease,

                                        lease.id,

                                        "contractCount",

                                        v,

                                        e,

                                        false,

                                    )

                                }

                                data={lease.contractCount}

                            />

                        </Th_title>

                        <Th_title title={"리스 계약번호"} colspan={1} className="fieldset-td" auth={fieldAuth}>

                            <SimmsInput

                                onChange={(v) => inputOnChange(setLease, "number", v, false)}

                                update

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(setLease, updateLease, lease.id, "number", v, e, false)

                                }

                                data={lease.number}

                            />

                        </Th_title>

                    </tr>

                    <tr>

                        <Th_title title={"업체명"} colspan={3} className="fieldset-td" required auth={fieldAuth}>

                            <Selector

                                onChange={(v) =>

                                    onUpdateClickListener(setLease, updateLease, "company", lease, v, true)

                                }

                                data={lease.company}

                                entity={"company"}

                                uniqueKey={"company"}

                            >

                                <SimmsInputSearch type={"TEXT"} placeHolder={"업체명"} />

                            </Selector>

                        </Th_title>

                    </tr>

                    <tr>

                        <Th_title title={"계약기간"} colspan={3} className="fieldset-td fieldset-td-input">

                            <div className="web-flex asset-detail-date-range">

                                <SimmsDatePicker

                                    onChange={(v) => dateOnChange(setLease, "leaseStartDate", v, false)}

                                    data={lease.leaseStartDate}

                                    update

                                    onUpdate={(v) =>

                                        dateOnSelected(

                                            setLease,

                                            updateLease,

                                            lease.id,

                                            "leaseStartDate",

                                            v,

                                            false,

                                        )

                                    }

                                    constraint={{

                                        lessThan: lease.leaseEndDate && dayjs(lease.leaseEndDate),

                                    }}

                                    auth={fieldAuth}

                                />

                                <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>

                                <SimmsDatePicker

                                    onChange={(v) => dateOnChange(setLease, "leaseEndDate", v, false)}

                                    data={lease.leaseEndDate}

                                    update

                                    onUpdate={(v) =>

                                        dateOnSelected(

                                            setLease,

                                            updateLease,

                                            lease.id,

                                            "leaseEndDate",

                                            v,

                                            false,

                                        )

                                    }

                                    constraint={{

                                        largerThan: lease.leaseStartDate && dayjs(lease.leaseStartDate),

                                    }}

                                    auth={fieldAuth}

                                />

                            </div>

                        </Th_title>

                    </tr>

                    <tr>

                        <Th_title title={"취득원가"} colspan={1} className="fieldset-td" auth={fieldAuth}>

                            <SimmsInput

                                onChange={(v) => inputOnChange(setLease, "cost", v, false)}

                                update

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(setLease, updateLease, lease.id, "cost", v, e, false)

                                }

                                data={lease.cost}

                            />

                        </Th_title>

                        <Th_title title={"1회 리스료(10회)"} colspan={1} className="fieldset-td" auth={fieldAuth}>

                            <SimmsInput

                                onChange={(v) => inputOnChange(setLease, "price", v, false)}

                                update

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(setLease, updateLease, lease.id, "price", v, e, false)

                                }

                                data={lease.price}

                            />

                        </Th_title>

                    </tr>

                    <tr>

                        <Th_title title={"비고"} colspan={3} className="fieldset-td fieldset-td-input" auth={fieldAuth}>

                            <SimmsTextArea

                                onChange={(v) => inputOnChange(setLease, "etc", v, false)}

                                update

                                style={{width: "100%"}}

                                onKeyDown={(v, e) =>

                                    inputOnKeyDown(setLease, updateLease, lease.id, "etc", v, e, false)

                                }

                                data={lease.etc}

                            />

                        </Th_title>

                    </tr>

                    <tr className={isEditing ? "asset-detail-kv-row--auto" : undefined}>

                        <th>자산목록</th>

                        <td colSpan={3} className="fieldset-td relative align-top">

                            {renderSelectionList({

                                data: assets,

                                countUnit: "개",

                                entity: "asset",

                                uniqueKey: "assets",

                                placeHolder: "자산명",

                                onRemove: (v) => AssetsDeleteHandler(lease.id, v),

                                onMultiFlat: handleAssetsMultiFlat,

                                filters: <AssetSearchFilters platFrom={platFrom} />,
                                listModalTitle: "자산목록",

                            })}

                        </td>

                    </tr>

                    <tr className={isEditing ? "asset-detail-kv-row--auto" : undefined}>

                        <th>계약목록</th>

                        <td colSpan={3} className="fieldset-td relative align-top">

                            {renderSelectionList({

                                data: contracts,

                                countUnit: "건",

                                entity: "contract",

                                uniqueKey: "contracts",

                                placeHolder: "계약명",

                                onRemove: (v) => ContractDeleteHandler(lease.id, v),

                                onMultiFlat: handleContractsMultiFlat,

                                filters: <SimmsInputSearch type="TEXT" placeHolder="계약명" />,
                                listModalTitle: "계약목록",

                            })}

                        </td>

                    </tr>

                    </tbody>

                </DetailKvTable>

            </DetailPanel>

            }

            aside={

            <DetailFilePanel

                isEditing={isEditing}

                tableInfo={{tableName: "AssetLease", joinKey: lease.id}}

            />

            }

        />

    );

}



export {AssetLeaseInfo};


